import registerImage from "../../assets/registerimage.png";
import "./registerUser.css";
import { useEffect, useState } from "react";
import { FaUserCircle, FaBuilding } from "react-icons/fa";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Locationdetails } from "../../env/action";
import { Registration } from "../../env/action";
import {
  CheckServiceAvailability, cityDetails,
  districtDetails,
  stateDetails
} from "../../env/action";
import debounce from 'lodash.debounce';

const RegisterUser = () => {
  const [activeTab, setActiveTab] = useState("basic-details");
  const [loading, setLoading] = useState(false);
  const [pincode, setPincode] = useState("");
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [wpmobile, setWpMobile] = useState("");
  const [aadharnumber, setAadharNumber] = useState("");
  const [email, setEmail] = useState("");
  const [image, setImage] = useState(null);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [pincodeError, setPincodeError] = useState("");
  const [address, setAddress] = useState("");
  const [locality, setLocality] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [isServiceAvailable, setIsServiceAvailable] = useState(false);
  const [age, setAge] = useState("");

  const [cityEditableManually, setCityEditableManually] = useState(false);
  const [distEditableManually, setDistEditableManually] = useState(false);
  const [stateEditableManually, setStateEditableManually] = useState(false);

  const [citySuggestions, setCitySuggestions] = useState([]);
  const [districtSuggestions, setDistrictSuggestions] = useState([]);
  const [stateSuggestions, setStateSuggestions] = useState([]);
  const [manualstatus, setManualStatus] = useState("0");

  const navigate = useNavigate();
  const handleBasicSubmit = (e) => {
    e.preventDefault();

    setActiveTab("address-details");
  };

  const checkServiceAvailability = (cityName) => {
    return new Promise((resolve) => {
      if (!cityName) return resolve(false);

      const params = { city: cityName };

      CheckServiceAvailability(params, (res) => {

        if (res.status === 1) {
          setIsServiceAvailable(true);
          resolve(true);
        } else {
          setIsServiceAvailable(false);
          toast.error(res.message, "", [
            {
              text: "OK",
              onPress: () => {
                setPincode(null);
                setCity(null);
                setDistrict(null);
                setState(null);
                setCitySuggestions([]);
                setDistrictSuggestions([]);
                setStateSuggestions([]);
                resolve(false);
              },
            },
          ]);
        }
      });
    });
  };

  const handleAddressSubmit = (e) => {
    e.preventDefault();
    //toast.success("");
    // navigate("/success");
  };

  // const handlePasswordChange = (text) => {
  //   setPassword(text);
  //   if (text.length < 8) {
  //     setPasswordError("Password must be at least 8 characters.");
  //   } else if (confirmPassword && confirmPassword !== text) {
  //     setPasswordError("Passwords do not match");
  //   } else {
  //     setPasswordError("");
  //   }
  // };

  const handlePasswordChange = (text) => {
    // setPassword(text);
    // const hasLetter = /[a-zA-Z]/.test(text);
    // const hasNumber = /[0-9]/.test(text);
    // const hasSpecialChar = /[^a-zA-Z0-9]/.test(text);

    // if (text.length < 8) {
    //   setPasswordError("Password must be at least 8 characters.");
    // } else if (!hasLetter) {
    //   setPasswordError("Password must contain at least one letter.");
    // } else if (!hasNumber) {
    //   setPasswordError("Password must contain at least one number.");
    // } else if (!hasSpecialChar) {
    //   setPasswordError("Password must contain at least one special character.");
    // } else if (confirmPassword && confirmPassword !== text) {
    //   setPasswordError("New Password and Confirm Password do not match");
    //   setPasswordError("");
    // } else {
    //   setPasswordError("");
    //   setPasswordError("");
    // }
   const hasNumber = /[0-9]/.test(text);
     const numericText = text.replace(/[^0-9]/g, "");
     setPassword(numericText);


    if (text.length < 8) {
      setPasswordError("Password must be at least 8 digits.");
    } else if (!hasNumber) {
     setPasswordError("Password must contain only digits.");
    } else if (confirmPassword && confirmPassword !== text) {
     setPasswordError("New Password and Confirm Password do not match");
     setPasswordError("");
    } else {
     setPasswordError("");
      setPasswordError("");
    }
  };

  const handleConfirmPasswordChange = (text) => {
    // setConfirmPassword(text);
     const numericText = text.replace(/[^0-9]/g, "");
  setConfirmPassword(numericText);
    if (password !== text) {
      setPasswordError("Passwords do not match");
    } else {
      setPasswordError("");
    }
  };

  const handlePincode = (pincode) => {
    setPincode(pincode);
    if (pincode.length !== 6) {
      setPincodeError("Pincode must be 6 digits");
    } else {
      setPincodeError("");
    }
  };

  const fetchSuggestions = debounce((type, query) => {
    if (!query || query.trim() === "") {
      if (type === "city") setCitySuggestions([]);
      if (type === "district") setDistrictSuggestions([]);
      if (type === "state") setStateSuggestions([]);
      return;
    }
    console.log("Debounced FetchSuggestions:", type, query);

    const callback = (res) => {
      console.log(res, 'city response')

      if (res.status === 1) {
        if (type === "city") setCitySuggestions(res.data);
        if (type === "district") setDistrictSuggestions(res.data);
        if (type === "state") setStateSuggestions(res.data);
      } else {
        console.warn(`No ${type} suggestions found`);
      }
    };

    try {
      if (type === "city") {
        cityDetails(query, callback);
      } else if (type === "district") {
        districtDetails(query, callback);
      } else if (type === "state") {
        stateDetails(query, callback);
      }
    } catch (error) {
      console.error(`Error fetching ${type} suggestions:`, error);
    }
  }, 300);

  const fetchLocationDetails = (pincode) => {
    try {
      Locationdetails({ pincode }, (response) => {
        console.log("Location API response:", response);
        if (response.status === 1) {
          if (
            response.data.city == "" &&
            response.data.district == "" &&
            response.data.state == ""
          ) {
            setPincodeError("Invalid Pincode");
          } else {
            setPincodeError("");
          }
          setCity(response.data.city);
          setDistrict(response.data.district);
          setState(response.data.state);

          setCityEditableManually(response.data.city === "");
          setDistEditableManually(response.data.district === "");
          setStateEditableManually(response.data.state === "");
          if (response.data.city) {
            checkServiceAvailability(response.data.city);
          }
        } else {
          toast.error("Could not fetch location data.");
        }
      });
    } catch (error) {
      console.error("Error fetching location:", error);
      toast.error("Something went wrong while fetching location data.");
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const calculateAge = (dobValue) => {
    const birthDate = new Date(dobValue);
    const today = new Date();
    let calculatedAge = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      calculatedAge--;
    }

    return calculatedAge;
  };
  const handleDateChange = (e) => {
    const dobValue = e.target.value;
    const calculatedAge = calculateAge(dobValue);

    if (calculatedAge < 18) {
      alert("Age must be 18 or above.");
      setDob("");
      setAge("");
    } else {
      setDob(dobValue);
      setAge(String(calculatedAge));
    }
  };

  const handleSignup = async () => {
    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }
    if (!state || state.trim() === "") {
      toast.error("Validation Error", "State is required.");
      return;
    }

    if (!district || district.trim() === "") {
      toast.error("Validation Error", "District is required.");
      return;
    }

    if (!city || city.trim() === "") {
      toast.error("Validation Error", "City is required.");
      return;
    }

    let serviceOk = true;
    if (cityEditableManually === true) {
      serviceOk = await checkServiceAvailability(city);
    }
    console.log('Service available:', serviceOk);

    if (!serviceOk) {
      return;
    }
    const params = {
      phone_number: mobile,
      email: email,
      password: password,
      role_id: 2,
      source: "web",
      name: name,
      gender: gender,
      address: address,
      locality: locality,
      pincode: pincode,
      state: state,
      dist: district,
      city: city,
      wp_number: wpmobile,
      aadhar_number: aadharnumber,
      dob: dob,
      image: image,
      age: age,
    };
    Registration(params, (res) => {
      if (res) {
        if (res.status === 0) {
          toast.error(res.message);
        } else if (res.status === 1) {
          toast.success(res.message);
          navigate("/login");
        } else {
          toast.error(res.message);
        }
      } else {
        toast.error("Unexpected response from server.");
      }
    });
  };

  return (
    <div className="container mt-2 mb-5 registerUser">
      <div className="row">
        <div className="col-lg-6 col-md-12">
          <div className="shadow mt-5 p-4">
            <h2>Registration for user</h2>
            <ul className="custom-tabs mb-1">
              <li
                className={activeTab === "basic-details" ? "active blue" : ""}
                onClick={() => setActiveTab("basic-details")}
              >
                <a className="details">
                  <FaUserCircle
                    style={{ fontSize: "25px" }}
                    className="me-2 icon"
                  />
                  <span style={{ fontSize: "14px" }}>Basic Details</span>
                </a>
              </li>
              <li
                className={activeTab === "address-details" ? "active blue" : ""}
                onClick={() => setActiveTab("address-details")}
              >
                <a className="details">
                  <FaBuilding
                    className="ms-3 p-1 me-2 icon"
                    style={{ fontSize: "25px", borderRadius: "50%" }}
                  />
                  <span style={{ fontSize: "14px" }}>Address Details</span>
                </a>
              </li>
            </ul>
            {activeTab === "basic-details" && (
              <form onSubmit={handleBasicSubmit}>
                <div className="mb-1 mt-3">
                  <label htmlFor="name" className="form-label">
                    Name:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-1">
                  <label htmlFor="mobile" className="form-label">
                    Mobile Number:
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    id="mobile"
                    name="mobile"
                    maxLength="10"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-1">
                  <label htmlFor="whatsapp" className="form-label">
                    WhatsApp Number:
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    id="whatsapp"
                    name="whatsapp"
                    maxLength="10"
                    value={wpmobile}
                    onChange={(e) => setWpMobile(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-1">
                  <label htmlFor="aadharLast4" className="form-label">
                    Last 4 Digits of Aadhaar:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="aadharLast4"
                    name="aadharLast4"
                    maxLength="4"
                    pattern="\d{4}"
                    title="Enter exactly 4 digits"
                    value={aadharnumber}
                    onChange={(e) => setAadharNumber(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-1">
                  <label htmlFor="email" className="form-label">
                    Email:
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-1">
                  <label
                    htmlFor="selectDate"
                    className="form-label fw-bold mb-2"
                  >
                    Date of Birth
                  </label>
                  <input
                    type="date"
                    id="fromDate"
                    className="form-control"
                    value={dob}
                    onChange={handleDateChange}
                    required
                  />
                </div>

                <div className="mb-1">
                  <label htmlFor="age" className="form-label">
                    Age
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="age"
                    name="age"
                    value={age}
                    readOnly
                  />
                </div>

                <div className="mb-1">
                  <label htmlFor="password" className="form-label">
                    Password:
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    name="password"
                    maxLength="15"
                    minLength="8"
                    value={password}
                    onChange={(e) => handlePasswordChange(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-1">
                  <label htmlFor="confirmPassword" className="form-label">
                    Confirm Password:
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="confirmPassword"
                    name="confirmPassword"
                    maxLength="15"
                    minLength="8"
                    value={confirmPassword}
                    onChange={(e) =>
                      handleConfirmPasswordChange(e.target.value)
                    }
                    required
                  />
                  {passwordError ? (
                    <p
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {passwordError}
                    </p>
                  ) : null}
                </div>
                <div className="mb-1">
                  <label htmlFor="photo" className="form-label">
                    Upload Photo:
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="photo"
                    name="photo"
                    accept="image/*"
                    //value={image}
                    onChange={handleImageChange}
                    required
                  />
                </div>
                <div className="mb-1">
                  <label className="form-label">Gender:</label>
                  <div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="gender"
                        id="genderMale"
                        value="male"
                        checked={gender === "male"}
                        onChange={(e) => setGender(e.target.value)}
                      />
                      <label className="form-check-label" htmlFor="genderMale">
                        Male
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="gender"
                        id="genderFemale"
                        value="female"
                        checked={gender === "female"}
                        onChange={(e) => setGender(e.target.value)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="genderFemale"
                      >
                        Female
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="gender"
                        id="genderOther"
                        value="other"
                        checked={gender === "other"}
                        onChange={(e) => setGender(e.target.value)}
                      />
                      <label className="form-check-label" htmlFor="genderOther">
                        Other
                      </label>
                    </div>
                  </div>
                </div>
                <button type="submit" value="Submit" className="nxt">
                  Next
                </button>
              </form>
            )}

            {activeTab === "address-details" && (
              <form onSubmit={handleAddressSubmit}>
                {/* <div className="mb-1 mt-3">
                  <label htmlFor="pincode" className="form-label">
                    Pincode:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="pincode"
                    name="pincode"
                    // maxLength="6"
                    // pattern="\d{6}"
                    title="Enter a valid 6-digit pincode"
                    value={pincode}
                    onChange={(e) => {
                      if (e.target.value.length === 6) {
                        fetchLocationDetails(e.target.value);
                      }
                    }}
                    required
                  />
                </div> */}

                <div className="mb-1 mt-3">
                  <label htmlFor="name" className="form-label">
                    Pincode:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="pincode"
                    name="pincode"
                    value={pincode}
                    minLength="6"
                    maxLength="6"
                    pattern="\d{6}"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        setPincode(value);
                        handlePincode(value);
                        if (value.length === 6) {
                          fetchLocationDetails(value);
                        }
                      }
                    }}
                    required
                  />
                  {pincodeError ? (
                    <p
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {pincodeError}
                    </p>
                  ) : null}
                </div>

                <div className="mb-1">
                  <label htmlFor="state" className="form-label">
                    State:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="state"
                    name="state"
                    placeholder="Enter your state"
                    value={state}
                    onChange={(e) => {
                      const text = e.target.value;
                      setState(text);

                      if (stateEditableManually) {
                        if (text.trim() === "") {
                          setStateSuggestions([]);
                        } else {
                          fetchSuggestions("state", text);
                        }
                      }
                    }}
                    disabled={!stateEditableManually}
                  />
                  {stateSuggestions.length > 0 && (
                    <ul className="suggestions-list" style={{
                      listStyleType: 'none',
                      padding: 0,
                      margin: 0,
                      border: '1px solid #ccc',
                      borderTop: 'none',
                      position: 'absolute',
                      width: '100%',
                      backgroundColor: 'white',
                      zIndex: 10,
                      maxHeight: '150px',
                      overflowY: 'auto'
                    }}>
                      {stateSuggestions.map((item, index) => (
                        <li
                          key={index}
                          onClick={() => {
                            setState(item.state_name);
                            setStateSuggestions([]);
                          }}
                          style={{
                            padding: '8px',
                            cursor: 'pointer',
                            borderBottom: '1px solid #eee'
                          }}
                          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f1f1f1'}
                          onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'white'}
                        >
                          {item.state_name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                <div className="mb-1">
                  <label htmlFor="district" className="form-label">
                    District:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="district"
                    name="district"
                    placeholder="Enter your district"
                    value={district}
                    onChange={(e) => {
                      const text = e.target.value;
                      setDistrict(text);

                      if (distEditableManually) {
                        if (text.trim() === "") {
                          setDistrictSuggestions([]);
                        } else {
                          fetchSuggestions("district", text);
                        }
                      }
                    }}
                    disabled={!distEditableManually}
                  />
                  {districtSuggestions.length > 0 && (
                    <ul className="suggestions-list" style={{
                      listStyleType: 'none',
                      padding: 0,
                      margin: 0,
                      border: '1px solid #ccc',
                      borderTop: 'none',
                      position: 'absolute',
                      width: '100%',
                      backgroundColor: 'white',
                      zIndex: 10,
                      maxHeight: '150px',
                      overflowY: 'auto'
                    }}>
                      {districtSuggestions.map((item, index) => (
                        <li
                          key={index}
                          onClick={() => {
                            setDistrict(item.dist_name);
                            setDistrictSuggestions([]);
                          }}
                          style={{
                            padding: '8px',
                            cursor: 'pointer',
                            borderBottom: '1px solid #eee'
                          }}
                          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f1f1f1'}
                          onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'white'}
                        >
                          {item.dist_name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                <div className="mb-1">
                  <label htmlFor="city" className="form-label">
                    City:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="city"
                    name="city"
                    placeholder="Enter your city"
                    value={city}
                    onChange={(e) => {
                      const text = e.target.value;
                      setCity(text);

                      if (cityEditableManually) {
                        if (text.trim() === "") {
                          setCitySuggestions([]);
                        } else {
                          fetchSuggestions("city", text);
                        }
                      }
                    }}
                    disabled={!cityEditableManually}
                  />
                  {citySuggestions.length > 0 && (
                    <ul className="suggestions-list" style={{
                      listStyleType: 'none',
                      padding: 0,
                      margin: 0,
                      border: '1px solid #ccc',
                      borderTop: 'none',
                      position: 'absolute',
                      width: '100%',
                      backgroundColor: 'white',
                      zIndex: 10,
                      maxHeight: '150px',
                      overflowY: 'auto'
                    }}>
                      {citySuggestions.map((item, index) => (
                        <li
                          key={index}
                          onClick={() => {
                            setCity(item.city_name);
                            setCitySuggestions([]);
                          }}
                          style={{
                            padding: '8px',
                            cursor: 'pointer',
                            borderBottom: '1px solid #eee'
                          }}
                          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f1f1f1'}
                          onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'white'}
                        >
                          {item.city_name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                <div className="mb-1">
                  <label htmlFor="address" className="form-label">
                    Address:
                  </label>
                  <textarea
                    className="form-control"
                    id="address"
                    name="address"
                    rows="3"
                    placeholder="Address (House No, Building, Street, Area)"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    required
                  ></textarea>
                </div>
                <div className="mb-1">
                  <label htmlFor="locality" className="form-label">
                    Locality/Town
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="locality"
                    name="locality"
                    placeholder="Enter your Locality"
                    value={locality}
                    onChange={(e) => setLocality(e.target.value)}
                    required
                  />
                </div>
                <button
                  type="submit"
                  value="Register"
                  className="nxt"
                  onClick={handleSignup}
                >
                  Register
                </button>
              </form>
            )}
          </div>
        </div>
        <div className="col-lg-6 col-md-12">
          <img src={registerImage} alt="Registration" className="img-fluid" />
        </div>
      </div>
    </div>
  );
};

export default RegisterUser;
